import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import ErrorHandler from 'hoc/withErrorHandler/errorHandler';
import ErrorBoundary from 'shared/components/errorBoundary/errorBoundary';
import i18n from 'shared/util/localization';

import App from './app';
import store from './store';

import 'assets/styles/app.scss';

const Root: React.FC = () => {
	return (
		<I18nextProvider i18n={i18n}>
			<Provider store={store}>
				<ErrorBoundary>
					<BrowserRouter>
						<ErrorHandler />
						<App />
					</BrowserRouter>
				</ErrorBoundary>
			</Provider>
		</I18nextProvider>
	);
};

export default Root;
